var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 45.6426C26 53.5573 32.2771 60 39.9961 60C47.7151 60 54 53.5573 54 45.6507C54 42.6585 53.0361 40.5994 51.986 38.8219L41.5634 21.1185C41.1559 20.4187 40.4036 19.9843 39.6121 20.0004C38.8128 20.0085 38.0761 20.4589 37.6843 21.1667L27.8259 38.9747C26.5486 41.2831 26 43.2779 26 45.6426ZM43.8655 40.4084C44.3537 39.8639 45.1456 39.8639 45.6337 40.4084C46.1221 40.9529 46.1221 41.8356 45.6337 42.3802L39.1658 49.5915C38.9217 49.8639 38.6016 50 38.2817 50C37.9618 50 37.6417 49.8638 37.3975 49.5915L34.3663 46.2118C33.8779 45.6673 33.8779 44.7846 34.3663 44.2401C34.8546 43.6956 35.6464 43.6956 36.1347 44.2401L38.2818 46.6339L43.8655 40.4084Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommon);
export default __webpack_public_path__ + "static/media/common.942aacb93d47f71ff1d470b67ab6deed.svg";
export { ForwardRef as ReactComponent };